const relacao_de_alunos_sem_certidao_de_nascimento = [
  {
    path: "/relacao-de-alunos-sem-certidao-de-nascimento",
    redirect: "/relacao-de-alunos-sem-certidao-de-nascimento",
    meta: {
      breadCrumb: "Gestão - Apoio Gerencial Gestão de Classe",
    },
    children: [
      {
        path: "/relacao-de-alunos-sem-certidao-de-nascimento",
        name: "relacao_de_alunos_sem_certidao_de_nascimento",
        component: () =>
          import(
            "@/views/RelacaoDeAlunosSemCertidaoDeNascimento/RelacaoDeAlunosSemCertidaoDeNascimento.vue"
          ),
      },
    ],
  },
];

export { relacao_de_alunos_sem_certidao_de_nascimento };
